var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.848877,
    y: 0.356079,
    width: 37.3936,
    height: 38.1609,
    rx: 8.18462,
    fill: "#142240"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7123 14.4365H27.879V16.1032H26.2123V26.9365C26.2123 27.1576 26.1245 27.3695 25.9683 27.5258C25.812 27.6821 25.6 27.7699 25.379 27.7699H13.7123C13.4913 27.7699 13.2794 27.6821 13.1231 27.5258C12.9668 27.3695 12.879 27.1576 12.879 26.9365V16.1032H11.2123V14.4365H15.379V11.9365C15.379 11.7155 15.4668 11.5036 15.6231 11.3473C15.7794 11.191 15.9913 11.1032 16.2123 11.1032H22.879C23.1 11.1032 23.312 11.191 23.4683 11.3473C23.6245 11.5036 23.7123 11.7155 23.7123 11.9365V14.4365ZM17.0457 18.6032V23.6032H18.7123V18.6032H17.0457ZM20.379 18.6032V23.6032H22.0457V18.6032H20.379ZM17.0457 12.7699V14.4365H22.0457V12.7699H17.0457Z",
    fill: "#FF2F04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9.54565 9.43652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.c92dce7400c2f7136aa36d70b05ebaf8.svg";
export { ForwardRef as ReactComponent };